import { logger as N } from "../../shared-lib/index.js";
export function toggleLogging() {
  N.toggleLogging();
}
